import { SwotSupportDetails } from "@swot";
import { useCmtsSelector } from "../../store/hooks.js";
import { selectPwaState } from "../../store/selectors.js";

export function CmtsPwaCacheCleanupStatus() {
  const pwa = useCmtsSelector(selectPwaState);
  if (pwa.cacheCleanupStatus === "idle") return null;
  return (
    <SwotSupportDetails correlationId={pwa.serviceWorkerVersion} diagnostics={{ status: pwa.cacheCleanupStatus, deletedCaches: pwa.deletedCaches.join(", "), preservedCaches: String(pwa.preservedCaches.length), lastCleanupAt: pwa.lastCleanupAt ?? "" }} />
  );
}
